import axios from "axios";
import { createContext, useEffect, useState } from "react";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(
    // JSON.parse(sessionStorage.getItem("user")) || null
    {
      id: 101,
      name: "June",
      profilePic: "https://images.pexels.com/photos/2272854/pexels-photo-2272854.jpeg?auto=compress&cs=tinysrgb&w=600",
      coverPic: "https://images.pexels.com/photos/977460/pexels-photo-977460.jpeg?auto=compress&cs=tinysrgb&w=600",
      city: "Dhaka",
    }
  );

  const login = async (inputs) => {
    const res = await axios.post("http://localhost:30000/api/auths/login", inputs, {
      withCredentials: true
    });
    setCurrentUser(res.data);
  };


  useEffect(() => {
    sessionStorage.setItem("user", JSON.stringify(currentUser));
  }, [currentUser]);

  return (
    <AuthContext.Provider value={{ currentUser, login }}>
      {children}
    </AuthContext.Provider>
  );
};
